import {
  getChatVolumeReportRef,
  getHistoriesCollectionRef,
  getPageViewsReportRef,
  getSatisfactionReportRef,
  getVisitorReportRef,
} from "../../../firebase/collectionReferences";
import { getDocs, query, where } from "firebase/firestore";

const BATCH_SIZE = 30;

function batchArray(array, size) {
  const batches = [];
  for (let i = 0; i < array.length; i += size) {
    batches.push(array.slice(i, i + size));
  }
  return batches;
}

export const getChatSatisfaction = async (params) => {
  const { propertyIds, dateRange } = params;
  const formattedDates = [new Date(dateRange[0]), new Date(dateRange[1])];
  const satisfactionReportRef = getSatisfactionReportRef();
  const batches = batchArray(propertyIds, BATCH_SIZE);
  console.log("Batches:", batches);
  const results = await Promise.all(
    batches.map(async (batch) => {
      const satisfactionQuery = query(
        satisfactionReportRef,
        where("createdAt", ">=", formattedDates[0]),
        where("createdAt", "<=", formattedDates[1]),
        where("propertyId", "in", batch)
      );
      return (await getDocs(satisfactionQuery)).docs.map((row) => ({
        ...row.data(),
      }));
    })
  );

  return results.flat();
};

export const getPageViewsCount = async (params) => {
  const { propertyIds, dateRange } = params;
  const formattedDates = [new Date(dateRange[0]), new Date(dateRange[1])];
  const pageViewsRef = getPageViewsReportRef();
  const batches = batchArray(propertyIds, BATCH_SIZE);

  const results = await Promise.all(
    batches.map(async (batch) => {
      const pageViewsQuery = query(
        pageViewsRef,
        where("createdAt", ">=", formattedDates[0]),
        where("createdAt", "<=", formattedDates[1]),
        where("propertyId", "in", batch)
      );
      return (await getDocs(pageViewsQuery)).docs.map((row) => ({
        ...row.data(),
      }));
    })
  );

  return results.flat();
};

export const getChatCount = async (params) => {
  const { propertyIds, dateRange } = params;
  const formattedDates = [new Date(dateRange[0]), new Date(dateRange[1])];
  const chatVolumeRef = getChatVolumeReportRef();
  const batches = batchArray(propertyIds, BATCH_SIZE);

  const results = await Promise.all(
    batches.map(async (batch) => {
      const chatVolumeQuery = query(
        chatVolumeRef,
        where("createdAt", ">=", formattedDates[0]),
        where("createdAt", "<=", formattedDates[1]),
        where("propertyId", "in", batch)
      );
      return (await getDocs(chatVolumeQuery)).docs.map((row) => ({
        ...row.data(),
      }));
    })
  );

  return results.flat();
};

export const getVisitorCount = async (params) => {
  const { propertyIds, dateRange } = params;
  const formattedDates = [new Date(dateRange[0]), new Date(dateRange[1])];
  const visitorCountRef = getVisitorReportRef();
  const batches = batchArray(propertyIds, BATCH_SIZE);

  const results = await Promise.all(
    batches.map(async (batch) => {
      const visitorCountQuery = query(
        visitorCountRef,
        where("createdAt", ">=", formattedDates[0]),
        where("createdAt", "<=", formattedDates[1]),
        where("propertyId", "in", batch)
      );
      return (await getDocs(visitorCountQuery)).docs.map((row) => ({
        ...row.data(),
      }));
    })
  );

  return results.flat();
};

export async function getMissedChatsCount(propertyIds, dateRange) {
  const formattedDates = [new Date(dateRange[0]), new Date(dateRange[1])];
  const historiesRef = getHistoriesCollectionRef();
  const batches = batchArray(propertyIds, BATCH_SIZE);

  const counts = await Promise.all(
    batches.map(async (batch) => {
      const historyQuery = query(
        historiesRef,
        where("propertyId", "in", batch),
        where("createdAt", ">=", formattedDates[0]),
        where("createdAt", "<=", formattedDates[1]),
        where("missed", "==", true)
      );
      const missedChatsSnapshot = await getDocs(historyQuery);
      return missedChatsSnapshot.size;
    })
  );

  return counts.reduce((sum, count) => sum + count, 0);
}

export async function getNotEngagedChatsCount(propertyIds, dateRange) {
  const formattedDates = [new Date(dateRange[0]), new Date(dateRange[1])];
  const historiesRef = getHistoriesCollectionRef();
  const batches = batchArray(propertyIds, BATCH_SIZE);

  const counts = await Promise.all(
    batches.map(async (batch) => {
      const historyQuery = query(
        historiesRef,
        where("propertyId", "in", batch),
        where("createdAt", ">=", formattedDates[0]),
        where("createdAt", "<=", formattedDates[1]),
        where("engaged", "==", false)
      );
      const notEngagedChatsSnapshot = await getDocs(historyQuery);
      return notEngagedChatsSnapshot.size;
    })
  );

  return counts.reduce((sum, count) => sum + count, 0);
}
